import * as ActionTypes from "constants/ActionTypes";

export const adminGetMediaProcessingJobs = (status, mediaType, limit) => ({
  type: ActionTypes.ADMIN_GET_MEDIA_PROCESSING_JOBS_START,
  status,
  mediaType,
  limit,
});

export const adminGetMediaProcessingJobsSuccess = (payload) => ({
  type: ActionTypes.ADMIN_GET_MEDIA_PROCESSING_JOBS_SUCCESS,
  payload,
});

export const adminGetMediaProcessingJobsFailure = (error) => ({
  type: ActionTypes.ADMIN_GET_MEDIA_PROCESSING_JOBS_FAILURE,
  error,
});
